import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AboutModalBox/about-modal-box';
export var AboutModalBoxBrand = function AboutModalBoxBrand(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$src = _a.src,
      src = _a$src === void 0 ? '' : _a$src,
      alt = _a.alt,
      props = __rest(_a, ["className", "src", "alt"]);

  return React.createElement("div", Object.assign({
    className: css(styles.aboutModalBoxBrand, className)
  }, props), React.createElement("img", {
    className: css(styles.aboutModalBoxBrandImage),
    src: src,
    alt: alt
  }));
};